<ng-container [ngSwitch]="forPopup">
  <div
    class="activity for-popup"
    *ngSwitchCase="true"
    (click)="openActivityInfo($event)"
    [style.width.px]="itemWidth"
    [ngStyle]="getImage()"
  >
    <span class="date" *ngIf="item.expirationDate">
      until {{ item.expirationDate | date : 'MMM d' }}
    </span>
    <div class="emojis" *ngIf="placeList[0] && placeList[0].emojiUrl">
      <div class="emoji" [ngStyle]="getEmojiImage()"></div>
    </div>
    <div class="info">
      <span class="title">{{ item.title }}</span>
      <span class="at"
        >at
        <span *ngFor="let place of placeList; let last = last"
          >{{ place.titleWeb }} <span *ngIf="!last">,</span></span
        ></span
      >
    </div>
  </div>

  <div
    class="activity-list-item"
    [ngClass]="{ 'for-place-page': forBeaconPage }"
    *ngSwitchDefault
    (click)="openActivityInfo($event)"
  >
    <div
      class="activity-list-item-image"
      [style.width.px]="itemWidth"
      [ngStyle]="getImage(false)"
    >
      <div class="emojis" *ngIf="placeList[0] && placeList[0].emojiUrl">
        <div class="emoji" [ngStyle]="getEmojiImage()"></div>
      </div>
      <span class="date" *ngIf="item.expirationDate">
        until {{ item.expirationDate | date : 'MMM d' }}
      </span>
    </div>
    <div class="activity-list-item-info">
      <span class="title">{{ item.title }}</span>
      <span class="at"
        >at
        <span *ngFor="let place of placeList; let last = last"
          >{{ place.titleWeb }} <span *ngIf="!last">,</span></span
        ></span
      >
    </div>
    <div class="status activity-list-item-status">
      <button
        class="bm-button"
        *ngIf="item.cost > 0 && canPurchase && !displaySuccess"
      >
        <span
          *ngIf="item.cost"
          [translate]="'purchase.ticket-btn-text'"
          [translateParams]="{ cost: item.cost / 100 | currency }"
        ></span>
      </button>
      <button class="bm-button" *ngIf="item.cost === 0 && !displaySuccess">
        <span [translate]="'purchase.deal-btn-text-free'"></span>
      </button>
      <button class="bm-button" *ngIf="item.cost >= 0 && displaySuccess">
        <span [translate]="'purchase.already-has-btn'"></span>
      </button>
      <button class="bm-button" *ngIf="displayLimit && !displaySuccess">
        <span [translate]="'payment.error-limit-title'"></span>
      </button>
    </div>
  </div>
</ng-container>
